import React, {useRef, useState} from 'react';
import {MediaFile} from "types/MediaFile";
import {XIcon} from "@heroicons/react/solid";
import Spinner from "components/Spinner";
import {concatenate, toTitleCase} from "services/string";
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import {ModalContainer} from "../ModalContainer";
import {ModalSize} from "../ModalContainer/ModalContainer";

// Types ----

type MediaModalProps = {
    file: MediaFile | null
    show: boolean
    onClose: () => any
}

// Component ----

function MediaModal({ file, show, onClose }: MediaModalProps) {
    const [loaded, setLoaded] = useState<boolean>(false);

    const closeButtonRef = useRef<HTMLButtonElement>(null);

    function handleClose() {
        onClose();
    }

    return (
      <ModalContainer show={show} size={ModalSize.X_LARGE} onCancel={handleClose} showCancel={false}>
        <div className='relative w-full h-full'>
            <button type="button" className={concatenate(!loaded? 'sr-only' : '', file?.type === 'audio'? 'top-0' : 'top-0 lg:top-0', 'absolute right-0 z-20 bg-gray-500 p-1')} ref={closeButtonRef} onClick={handleClose}>
                <XIcon className='text-white h-6 w-6 drop-shadow-sm'/>
            </button>

            {!loaded &&
              <div className="absolute top-0 left-0 h-full w-full flex items-center justify-center">
                  <Spinner size={Spinner.sizes.MEDIUM} color={Spinner.colors.DARK} />
              </div>
            }


          {file &&
            <div className="relative">
                <div className='flex justify-center'>
                    {file.type === 'image' &&
                      <img className="max-h-[85vh]" src={file.original_url} alt={file.name} onLoad={() => setLoaded(true)} />
                    }

                    {file.type === 'document' &&
                      <img className="max-h-[85vh]" src={file.preview_url} alt={file.name} onLoad={() => setLoaded(true)} />
                    }

                    {file.type === 'audio' &&
                      <div className="mt-8 mb-2 mx-2 w-80 lg:w-96">
                          <AudioPlayer
                            autoPlay
                            src={file.original_url}
                            onLoadStart={() => setLoaded(true)}
                          />
                      </div>
                    }

                    {file.type === 'video' &&
                      <video
                        autoPlay
                        controls
                        src={file.original_url}
                        onLoadStart={() => setLoaded(true)}
                        className="max-h-[85vh]"
                      />
                    }
                </div>

                {loaded &&
                  <p className="font-semibold text-center text-sm py-2">
                      {toTitleCase(file.name)}
                  </p>
                }
            </div>
          }
        </div>
      </ModalContainer>
    );
}

export default MediaModal;